import { ThisReceiver } from '@angular/compiler';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { MoovInstanceStepData, MoovStepData } from 'src/app/moov-common/services/challenge/challenges-data';
import { MoovStepInstanceState } from 'src/app/moov-common/services/challenge/moovStepState.enum';


@Component({
 selector: 'app-moov-step',
 templateUrl: './moov-step.component.html',
 styleUrls: ['./moov-step.component.scss']
})
export class MoovStepComponent extends BaseComponent implements OnInit {
 @Input() stepDetails: MoovStepData;
 @Input() stepInstanceDetails: MoovInstanceStepData;
 @Input() isPastMoov: boolean = false;
 @Input() isStepInstance: boolean = false;
 @Input() isActiveStep: boolean = false;
 @Input() isSimpleView:boolean = true;
 @Output() stepDoneEvent = new EventEmitter<string>();
 @Output() stepPendingEvent = new EventEmitter<string>();
 @Output() updateStepCommentEvent = new EventEmitter<string>();
 @Output() stepInstanceDetailsChange : EventEmitter<MoovInstanceStepData> = new EventEmitter<MoovInstanceStepData>();
  presentCommentInput: boolean = false;
 commentIsDisabled: boolean = false;
 moovStepInstanceStateEnum = MoovStepInstanceState;
 currentStateIcon :string ="";
 userForcedCommentView : boolean = false;
 userForcedCommentViewValue: boolean = false;
 stepIsDone : boolean = false;
  tempComment : string = "";


 constructor() {
   super();
  }


 ngOnInit(): void {
   super.ngOnInit();


   if (this.isStepInstance){
     this.calcStepIsDone();
     this.setIconByState();
     this.calcPresentComment();
   }
 }


 ngOnChanges(changes: SimpleChanges): void {


   if (!(changes.stepInstanceDetails && changes.isActiveStep && changes.isPastMoov)){
     return;
   }


   if ((!changes.stepInstanceDetails.isFirstChange() && changes.stepInstanceDetails.currentValue != changes.stepInstanceDetails.previousValue) ||
       (!changes.isActiveStep.isFirstChange() && changes.isActiveStep.currentValue != changes.isActiveStep.previousValue ) ||
       (!changes.isPastMoov.isFirstChange() && changes.isPastMoov.currentValue != changes.isPastMoov.previousValue )){
        
       if (this.isStepInstance){
         this.calcStepIsDone();
         this.setIconByState();
         this.calcPresentComment();
       }
   }


   this.ifChanged(changes.isSimpleView, () => {
     this.calcPresentComment()
   });
 }


 setIconByState(): void{


   if (!this.isPastMoov && this.stepInstanceDetails.state== MoovStepInstanceState.Done){
     this.currentStateIcon = "check_circle";
   }
   else if (!this.isPastMoov){
     this.currentStateIcon = "radio_button_unchecked";
   }
   else if (this.isPastMoov && this.stepInstanceDetails.state == MoovStepInstanceState.Done){
     this.currentStateIcon = "done";
   }
   else if (this.isPastMoov){
     this.currentStateIcon = "question_mark";
   }
 }


 updateStepState():void {
   if (this.isPastMoov){
     return;
   }


   if (this.stepInstanceDetails.state == MoovStepInstanceState.Done){
     this.stepInstanceDetails.state = MoovStepInstanceState.Pending;
     this.stepPendingEvent.emit(this.stepInstanceDetails.id);
   }
   else{
     this.stepInstanceDetails.state = MoovStepInstanceState.Done;
     this.stepDoneEvent.emit(this.stepInstanceDetails.id);
     this.analytics.activeMoovStepCheckedEvent();
   }


   this.setIconByState();
   this.calcStepIsDone();
 }


 calcPresentComment():void{
   if (!this.isStepInstance){
     this.presentCommentInput = false;
   }


   // if the user chose to present / hide comment
   if (this.userForcedCommentView){
     this.presentCommentInput = this.userForcedCommentViewValue;
   }
   else if (this.isPastMoov){
     this.presentCommentInput = this.stepInstanceDetails.comment != "";
     this.userForcedCommentViewValue = this.presentCommentInput;
   }
   else if (this.isActiveStep || this.stepInstanceDetails.comment != ""){
     this.presentCommentInput = true;
     this.userForcedCommentViewValue = this.presentCommentInput;
   }
   else{
     this.presentCommentInput = false;
     this.userForcedCommentViewValue = this.presentCommentInput;
   }
 }


 calcStepIsDone(): void{
   this.stepIsDone = false;
   if (this.isStepInstance && this.stepInstanceDetails.state == MoovStepInstanceState.Done){
     this.stepIsDone = true;
   }
 }


 userCommentSubmitted(text:string): void{
  
   this.stepInstanceDetailsChange.emit(this.stepInstanceDetails);
   this.updateStepCommentEvent.emit(text);
   this.analytics.activeMoovStepCommentSavedEvent();
 }


 userForcedCommentValueChanged():void {
   this.userForcedCommentView = true;
   this.calcPresentComment();
 }
}
